import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._b({staticClass:"text-capitalize",attrs:{"color":_vm.color}},'v-btn',_vm.$attrs,false),[_vm._t("default",[_vm._t("prefix"),_vm._t("text"),_vm._t("suffix")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }